// Payments API methods — mixin applied to the ApiService prototype chain.
// Methods run with `this` bound to the ApiService instance, so this.request()
// and cross-domain calls resolve through the shared HttpClient base.
const withPaymentsApi = (Base) => class extends Base {
  async mixedQuote(cart, guest = false) {
    return this[guest ? 'publicRequest' : 'request']('/payments/guest/mixed-quote', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(cart) });
  }

  async createMixedPaymentIntent(cart) {
    return this.request('/payments/create-mixed-payment-intent', { method: 'POST', body: JSON.stringify(cart) });
  }

  // Product purchase API methods
  async createProductPaymentIntent(paymentData) {
    return this.request('/payments/create-product-payment-intent', {
      method: 'POST',
      body: JSON.stringify(paymentData)
    });
  }

  async confirmProductPayment(paymentData) {
    return this.request('/payments/confirm-product-payment', {
      method: 'POST',
      body: JSON.stringify(paymentData)
    });
  }

  async getPurchaseConfirmation(paymentIntentId) {
    return this.request(`/payments/confirmation/${paymentIntentId}`);
  }

  // Payment history API methods
  async getUserEnrollments() {
    return this.request('/payments/enrollments');
  }

  async getUserPurchases() {
    return this.request('/payments/purchases');
  }

  async searchAdminPurchases(search) {
    const query = search ? `?search=${encodeURIComponent(search)}` : '';
    return this.request(`/payments/admin/purchase-search${query}`);
  }

  async backfillPaymentMetadata(limit = 200) {
    return this.request('/payments/admin/backfill-payment-metadata', {
      method: 'POST',
      body: JSON.stringify({ limit }),
      timeout: 300000
    });
  }

  async getCommunityStudents() {
    return this.request('/courses/community');
  }

  // Server time API methods
  async getServerTime() {
    return this.request('/attendance/time/utc-now');
  }

  // Active attendance sessions for today
  async getActiveAttendanceSessionsToday() {
    return this.request('/attendance/active-today');
  }

};

export default withPaymentsApi;
